import { PermissionT } from "../types";

export const canCreateAmbasadorLead = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "ambassador_create");
  return !!p;
};

export default canCreateAmbasadorLead;
